<app-loading *ngIf="!contentReady"></app-loading>

<div class="container-fluid p-0 dentist-list-page" *ngIf="contentReady" dir="rtl" lang="ar">
  <div class="col-12 main-content">
    <div class="container-fluid mb-4">

      <!-- HEADER -->
      <div class="categoryContainer">
        <div class="col-12 toolbar-row">

          <button routerLink="/dentistform" class="first-btn btn btn-primary">
            إنشاء طبيب
          </button>

          <button type="button" (click)="refresh()" class="first-btn btn btn-primary">
            تحديث
          </button>

          <div class="input-group search-group">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="searchKey"
              placeholder="ابحث بالاسم أو الهاتف أو التخصص أو البريد الإلكتروني"
              (keyup.enter)="search()"
            />

            <button class="btn btn-outline-secondary" type="button" (click)="search()">
              بحث
            </button>

            <button
              class="btn btn-outline-secondary clear-btn"
              type="button"
              *ngIf="searchKey"
              (click)="clearSearch()"
            >
              مسح
            </button>
          </div>

        </div>
      </div>

      <!-- TABLE -->
      <div class="table-scroll">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100">

          <!-- صورة الطبيب -->
          <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef class="text-center">الصورة</th>

            <td mat-cell *matCellDef="let el" class="text-center">
              <img
                *ngIf="el.doctor_image_url"
                [src]="el.doctor_image_url"
                width="40"
                height="40"
                alt="صورة الطبيب"
              />

              <span *ngIf="!el.doctor_image_url">—</span>
            </td>
          </ng-container>

          <!-- الاسم -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>الاسم</th>

            <td mat-cell *matCellDef="let el">
              <strong class="name-text">{{ el.name || '—' }}</strong>

              <small *ngIf="el.email">{{ el.email }}</small>
              <small *ngIf="!el.email">لا يوجد بريد إلكتروني</small>
            </td>
          </ng-container>

          <!-- الهاتف -->
          <ng-container matColumnDef="mobile">
            <th mat-header-cell *matHeaderCellDef>الهاتف</th>

            <td mat-cell *matCellDef="let el">
              {{ el.mobile || '—' }}
            </td>
          </ng-container>

          <!-- التخصص -->
          <ng-container matColumnDef="specialty">
            <th mat-header-cell *matHeaderCellDef>التخصص</th>

            <td mat-cell *matCellDef="let el">
              {{ el.specialty || '—' }}
            </td>
          </ng-container>

          <!-- سنة الماجستير -->
          <ng-container matColumnDef="master_year">
            <th mat-header-cell *matHeaderCellDef>سنة الماجستير</th>

            <td mat-cell *matCellDef="let el">
              {{ el.master_year || '—' }}
            </td>
          </ng-container>

          <!-- سنة الدكتوراه -->
          <ng-container matColumnDef="phd_year">
            <th mat-header-cell *matHeaderCellDef>سنة الدكتوراه</th>

            <td mat-cell *matCellDef="let el">
              {{ el.phd_year || '—' }}
            </td>
          </ng-container>

          <!-- الشهادات -->
          <ng-container matColumnDef="certificates">
            <th mat-header-cell *matHeaderCellDef>الشهادات</th>

            <td mat-cell *matCellDef="let el">
              <span class="cert-badge" *ngIf="el.certificates_count">
                {{ el.certificates_count }} ملف
              </span>

              <span *ngIf="!el.certificates_count">—</span>
            </td>
          </ng-container>

          <!-- مستوى التصنيف -->
          <ng-container matColumnDef="scfhs_level">
            <th mat-header-cell *matHeaderCellDef>مستوى التصنيف</th>

            <td mat-cell *matCellDef="let el">
              {{ el.scfhs_level || '—' }}
            </td>
          </ng-container>

          <!-- سنوات الخبرة -->
          <ng-container matColumnDef="years">
            <th mat-header-cell *matHeaderCellDef>الخبرة</th>

            <td mat-cell *matCellDef="let el">
              {{ el.years_of_practice || '—' }}
            </td>
          </ng-container>

          <!-- مجموع النقاط -->
          <ng-container matColumnDef="score">
            <th mat-header-cell *matHeaderCellDef>السكور</th>

            <td mat-cell *matCellDef="let el">
              <strong>{{ el.total_score ?? '—' }}</strong>
            </td>
          </ng-container>

          <!-- التقييم -->
          <ng-container matColumnDef="band">
            <th mat-header-cell *matHeaderCellDef>التقييم</th>

            <td mat-cell *matCellDef="let el">
              <span
                class="badge"
                [ngClass]="{
                  'bg-success': el.band === 'priority',
                  'bg-warning': el.band === 'hold',
                  'bg-danger': el.band === 'not'
                }"
              >
                {{ el.band_label }}
              </span>
            </td>
          </ng-container>

          <!-- CV PDF -->
          <ng-container matColumnDef="cv">
            <th mat-header-cell *matHeaderCellDef class="text-center">السي في</th>

            <td mat-cell *matCellDef="let el" class="text-center">
              <a
                *ngIf="el.cv_url"
                [href]="el.cv_url"
                target="_blank"
                rel="noopener"
                class="btn btn-sm btn-outline-primary"
              >
                تحميل
              </a>

              <span *ngIf="!el.cv_url">—</span>
            </td>
          </ng-container>

          <!-- Portfolio -->
          <ng-container matColumnDef="portfolio">
            <th mat-header-cell *matHeaderCellDef class="text-center">البورتفوليو</th>

            <td mat-cell *matCellDef="let el" class="text-center">
              <a
                *ngIf="el.portfolio_link"
                [href]="el.portfolio_link"
                target="_blank"
                rel="noopener"
              >
                زيارة
              </a>

              <span *ngIf="!el.portfolio_link">—</span>
            </td>
          </ng-container>

          <!-- اتصال -->
          <ng-container matColumnDef="call">
            <th mat-header-cell *matHeaderCellDef class="text-center">اتصال</th>

            <td mat-cell *matCellDef="let el" class="text-center chat">
              <img
                src="/assets/call.png"
                alt="اتصال"
                title="اتصال"
                (click)="call(el.mobile)"
              />
            </td>
          </ng-container>

          <!-- واتساب -->
          <ng-container matColumnDef="chat">
            <th mat-header-cell *matHeaderCellDef class="text-center">واتساب</th>

            <td mat-cell *matCellDef="let el" class="text-center chat">
              <img
                src="/assets/chat.png"
                alt="واتساب"
                title="واتساب"
                (click)="chat(el.whatsapp_number || el.mobile)"
              />
            </td>
          </ng-container>

          <!-- إجراءات -->
          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef>إجراءات</th>

            <td mat-cell *matCellDef="let el">
              <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>

                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" (click)="details(el.id)">
                      تفاصيل
                    </a>
                  </li>

                  <li *ngIf="canEdit">
                    <a class="dropdown-item" (click)="edit(el.id)">
                      تعديل
                    </a>
                  </li>

                </ul>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
      </div>

      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 20, 50, 100]"
        (page)="onPaginateChange($event)"
      >
      </mat-paginator>

      <app-nodata *ngIf="noData"></app-nodata>

    </div>
  </div>
</div>
